module.exports = __webpack_public_path__ + "static/media/icon-coin.591fa5f1.svg";